import type { ComponentContentSchema } from '@vibesites/runtime';
import { useContentToken, RichTextContent } from '@vibesites/runtime/react';

function hasValue(val: string | null | undefined): val is string {
  if (!val) return false;
  const normalized = val.trim().toLowerCase();
  return normalized !== '' && normalized !== 'false' && normalized !== 'null' && normalized !== 'undefined';
}

/**
 * Pricing disclaimer above the floor plans grid. Adapted from Weidner Blue
 * Haven's FloorPlansIntro — Homestead already covers heading/body in the hero,
 * so this slot only surfaces custom_pricing_verbiage.
 */
export function FloorPlansIntro() {
  const pricingVerbiage = useContentToken('floorplansintro.pricing_verbiage');

  return (
    <section className="w-full bg-[var(--vibe-color-background)]">
      {hasValue(pricingVerbiage) && (
        <div className="mx-auto max-w-3xl px-4 pb-4 pt-2 text-center sm:px-6 md:pb-6 md:pt-4 lg:px-8">
          <RichTextContent
            path="floorplansintro.pricing_verbiage"
            label="Pricing Verbiage"
            as="p"
            className="font-body text-sm leading-relaxed text-[var(--vibe-color-text-muted)] sm:text-base [&_a]:text-primary [&_a]:underline [&_p]:mb-0"
          />
        </div>
      )}
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FloorPlansIntro',
  displayName: 'Floor Plans Intro',
  tokens: {
    'floorplansintro.pricing_verbiage': {
      label: 'Pricing Verbiage',
      type: 'richtext',
      defaultField: 'custom_pricing_verbiage',
    },
  },
};

(FloorPlansIntro as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default FloorPlansIntro;
